// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ODnp","colBig":"styles_colBig__2Vog6","colSmall":"styles_colSmall__3Sz_8"};